import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_SUBSCRIPTIONS = "[SUBSCRIPTION REPORT] GET_SUBSCRIPTIONS";
export const GET_SUBSCRIPTIONS_SUCCESS =
	"[SUBSCRIPTION REPORT] GET_SUBSCRIPTIONS_SUCCESS";
export const GET_SUBSCRIPTIONS_FAILED =
	"[SUBSCRIPTION REPORT] GET_SUBSCRIPTIONS_FAILED";

export const SET_VALUE = "[SUBSCRIPTION REPORT] SET_VALUE";

export function setValue(payload) {
	return { type: SET_VALUE, payload };
}

export function getSubscriptions(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_SUBSCRIPTIONS });

		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/Subscription?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: "Bearer " + login.token,
				}
			);

			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_SUBSCRIPTIONS_SUCCESS,
						payload: result.model,
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params,
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_SUBSCRIPTIONS_FAILED,
					payload: errors,
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_SUBSCRIPTIONS_FAILED,
				payload: {
					error: "Connection error",
				},
			});
		}
	};
}